export const servicesData = [
  {
    id: 1,
    title: "Wisata Dalam Negeri",
    description: "Jelajahi kekayaan budaya dan pesona alam Nusantara. Dari pantai eksotis hingga pegunungan menyejukkan, kami memastikan momen perjalanan di tanah air menjadi kenangan tak terlupakan dengan layanan premium.",
    image: "/images/bali.jpg" // Bali
  },
  {
    id: 2,
    title: "Wisata Luar Negeri",
    description: "Wujudkan impian menjelajahi destinasi global ikonik. Kami mengelola seluruh logistik perjalanan internasional Anda, memastikan kenyamanan akomodasi eksklusif dan rute wisata terbaik.",
    image: "/images/paris1.jpg" // Paris, France
  },
  {
    id: 3,
    title: "Wisata Haji & Umrah",
    description: "Tunaikan ibadah ke Tanah Suci dengan khusyuk. Kami mengutamakan kenyamanan jamaah melalui hotel strategis bintang 5, transportasi VIP, serta pendampingan Mutawwif tersertifikasi.",
    image: "/images/mecca.jpg" // Mecca, Kaaba
  },
  {
    id: 4,
    title: "Wisata Religi",
    description: "Perdalam makna spiritual melalui kunjungan ke situs bersejarah dunia. Paket dirancang untuk memberikan wawasan sejarah sejarah Islam dalam suasana perjalanan yang khidmat.",
    image: "/images/turkey.jpg" // Blue Mosque, Turkey
  }
];

export const advantagesData = [
  {
    icon: "Shield",
    title: "Legalitas Terjamin",
    description: "Beroperasi dengan izin resmi kementerian, memberikan Anda ketenangan pikiran di setiap langkah perjalanan."
  },
  {
    icon: "Star",
    title: "Fasilitas Premium",
    description: "Kemitraan eksklusif dengan maskapai ternama dan jaringan hotel bintang 5 global."
  },
  {
    icon: "Users",
    title: "Pendamping Ahli",
    description: "Didampingi oleh Tour Leader profesional dan Mutawwif berpengalaman yang berdedikasi."
  },
  {
    icon: "Settings",
    title: "Layanan Tailor-Made",
    description: "Fleksibilitas penuh untuk merancang itinerary yang disesuaikan dengan preferensi pribadi Anda."
  }
];